/**
 * Counter home (Req 28.2): the three operator areas, each at its own URL so the browser
 * Back button and bookmarks work:
 *  - `/`          member lookup, then on-behalf code scanning, Invoice_Earn and
 *                 Point_Discount for that member;
 *  - `/handover`  Order handover;
 *  - `/queue`     offline scan queue review.
 *
 * Section navigation lives in the Shell (bottom tab bar / side rail), not here.
 */
import { Route, Routes } from 'react-router';
import type { OperatorScope } from '../auth/operator-scope';
import { useT } from '../hooks';
import { CounterPage } from './CounterPage';
import { HandoverPage } from './HandoverPage';
import { QueuePage } from './QueuePage';

export function HomePage({ scope }: { scope: OperatorScope }) {
  const t = useT();
  if (!scope.tenantId) {
    return <p role="alert">{t('operator.scope.noTenant')}</p>;
  }
  if (!scope.outletId) {
    return <p role="alert">{t('operator.scope.noOutlet')}</p>;
  }
  const outletId = scope.outletId;
  return (
    <Routes>
      {/* Keyed by tenant and outlet: switching either starts over with no member selected. */}
      <Route path="/handover" element={<HandoverPage key={`${scope.tenantId}|${outletId}`} outletId={outletId} />} />
      <Route path="/queue" element={<QueuePage />} />
      <Route path="*" element={<CounterPage key={`${scope.tenantId}|${outletId}`} outletId={outletId} />} />
    </Routes>
  );
}
